import { SxProps, Theme, Typography } from '@mui/material';
import { SIDE_PANEL_ROW_CONTENT_HEIGHT } from 'src/components/SidePanelRow';
import { toSxArray } from 'src/utils/sx';

export const FORM_LABEL_WIDTH = 'min(40%, 140px)';

export const FormLabel = ({ label, sx }: { label?: string; sx?: SxProps<Theme> }) => {
  return (
    <Typography
      sx={[
        {
          // reserving a full row's content height keeps the label on the same baseline
          // whether the value is one line or a wrapping list that grows beneath it
          display: 'flex',
          alignItems: 'center',
          minHeight: SIDE_PANEL_ROW_CONTENT_HEIGHT,
          width: FORM_LABEL_WIDTH,
          flexShrink: 0,
          fontSize: '0.8125rem',
          fontWeight: 400,
          lineHeight: 'normal',
          color: (theme) => theme.palette.custom.OV.sys.outline,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        ...toSxArray(sx),
      ]}
    >
      {label}
    </Typography>
  );
};
